<template>
  <div>
        <p class="text">—— 没有更多数据了 ——</p>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
    .text{
        text-align: center;
        color: rgba(255, 255, 255, 0.5);
        padding: 5% 0  0 !important;
    }
</style>